import { Navigate } from "react-router-dom";

import { useConsumerMarketplaceEnabled } from "../../hooks/useConsumerMarketplaceEnabled";

/**
 * SILL-504 — the one route gate for every consumer marketplace surface
 * (`/offers`, `/offers/:id`, `/market/agents/:id`,
 * `/market/agents/:id/offers/:ref`, `/marketplace/browse`). Replaces the
 * M5-era trio (OffersFlagGate / BrowseRoute flag check / AgentDetailGate's
 * either-or) so a missing or unloaded flag can never mean "live".
 *
 * Flag gate ONLY — no ProductRoute wrapper. Route elements mount
 * `ProductRoute` as their OUTERMOST component and stack this gate INSIDE
 * it, so React reconciles the auth/onboarding/legal gates across
 * navigation into/out of the marketplace group instead of remounting them
 * (remounting caused the white flash unique to /offers).
 */
export function MarketplaceRouteGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const enabled = useConsumerMarketplaceEnabled();
  if (!enabled) {
    return <Navigate replace to="/dashboard" />;
  }
  return <>{children}</>;
}
